import { render, staticRenderFns } from "./BrankSidebar.vue?vue&type=template&id=3a463ec8&"
import script from "./BrankSidebar.vue?vue&type=script&lang=js&"
export * from "./BrankSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BrankSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports